import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

export const getOrganizations = async (programName = 'MILITARY' /* MILITARY, FIRST_RESPONDER */) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('get sheer organizations', programName);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/program/${programName}`,
      method: 'GET',
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('get sheer organizations', data);
    return data;
  } catch (error) {
    console.error(error.message);
    logger.apiError('get sheer organizations', null, error.message);
    return { error: error.message };
  }
};

export const submitActiveMilitaryInfo = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit active military info', payload);
  try {
    const result = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/collectActiveMilitaryPersonalInfo`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit active military info', result?.data);
    return result?.data || result?.response?.data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit active military info', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('submit active military info', null, error);
    return Promise.reject(error);
  }
};

export const submitInactiveMilitaryInfo = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit inactive military info', payload);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/collectInactiveMilitaryPersonalInfo`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit inactive military info', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit inactive military info', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('submit inactive military info', null, error);
    return Promise.reject(error);
  }
};

export const associateBangoSubscription = async (subscriptionRequestId, redirectUrl) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/bango/associateSubscription`,
      method: 'PATCH',
      data: {
        subscriptionRequestId,
        redirectUrl,
      },
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    return data;
  } catch (error) {
    if (error?.response?.data) {
      return Promise.reject(error.response.data.errorMessage);
    }
    return Promise.reject(error);
  }
};

export const getMemberVerify = async () => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/user`,
      method: 'GET',
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    return data;
  } catch (error) {
    if (error?.response?.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
};
